import type {
  Option,
  Props as TokenListInputProps,
} from 'src/components/lib/token-list-input/token-list-input.old';
import type {DynamicLabels} from 'src/action-creators/dynamic-labels';

import * as React from 'react';

import {emptyArray} from 'src/utils';

import {MultiEntityVariableSelect} from 'src/components/lib/variable-picker';
import {MultiEntityLabel} from 'src/components/lib/markdown-editor/dynamic-text';

// @ts-expect-error - TS2314 - Generic type 'Props' requires 3 type argument(s).
type EmailListInputProps = TokenListInputProps & {
  value: string | null | undefined;
  onChange: (value: string) => unknown;
  rteMode: boolean; // if yes, wrap known values in <>;
};

const EmailListInput = ({
  value,
  values,
  onChange,
  options,
  hasError = false,
  rteMode = true,
  ...props
}: EmailListInputProps) => {
  const valueOptionMap = React.useMemo(
    () =>
      // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'option' implicitly has an 'any' type.
      options.reduce<Record<string, any>>((acc, option) => {
        acc[option.value] = option;
        return acc;
      }, {}),
    [options],
  );

  const handleChange = React.useCallback(
    (values: DynamicLabels) =>
      onChange(
        values
          ?.map(
            ({entity_type, value, rteValue}) =>
              entity_type && rteMode ? rteValue : value, // rteValue is equivalent to <value>
          )
          .join(', '),
      ),
    [onChange],
  );

  if (!value) {
    values = emptyArray;
  } else {
    // @ts-expect-error - TS7006 - Parameter 'email' implicitly has an 'any' type.
    values = value.split(', ').map((email) => {
      const knownTokenRegex = /\<(.*)\>/g;

      const knownToken = knownTokenRegex.exec(email);
      email = knownToken !== null ? knownToken[1] : email;
      return (
        valueOptionMap[email] || {
          label: email,
          value: email,
          sourceObject: {},
        }
      );
    });
  }
  return (
    <MultiEntityVariableSelect
      values={values}
      hasError={hasError}
      onChange={handleChange}
      verticalStretch={true}
      options={options}
      {...props}
    />
  );
};

export const EmailDynamicVarToken = ({
  option,
  children,
  dynamicLabels,
  type,
  className,
  onClick,
}: {
  dynamicLabels: DynamicLabels;
  // @ts-expect-error - TS2707 - Generic type 'Option' requires between 1 and 3 type arguments.
  option: Option & {
    extras: {
      resource?: string;
    };
  };
  children: React.ReactNode;
  className?: string;
  type: any;
  onClick: any;
}): React.ReactNode | React.ReactElement<React.ComponentProps<'div'>> => {
  const entityType = dynamicLabels.find((label) => label.label === option.label)
    ?.mapping?.sense_name;

  const {resource} = option.sourceObject;
  if (resource) {
    return (
      // @ts-expect-error - TS2739 - Type '{ children: ReactNode; type: any; className: string | undefined; onClick: any; entityType: any; }' is missing the following properties from type 'MultiEntityLabelComponentProps': baseEntityType, useNewDesignSystem
      <MultiEntityLabel {...{children, type, className, onClick, entityType}} />
    );
  }
  return <div {...{className, onClick}}>{children}</div>;
};

export default EmailListInput;
